import { useCallback } from 'react';

interface BeaconParams {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export function useBeaconRequest() {
  const sendBeaconRequest = useCallback(
    async (endpoint: string, params: BeaconParams): Promise<boolean> => {
      const paramBlob = new Blob([JSON.stringify(params)], { type: 'application/json' });
      const success = navigator.sendBeacon(endpoint, paramBlob);
      return success;
    },
    [],
  );

  const makeHttpRequest = useCallback(
    async (endpoint: string, params: BeaconParams): Promise<string> => {
      return new Promise((resolve, reject) => {
        const req = new XMLHttpRequest();
        req.onload = function () {
          if (req.status === 200) {
            resolve(req.responseText);
          } else {
            reject(new Error(`Request failed with status ${req.status}`));
          }
        };

        req.onerror = () => {
          reject(new Error('Network error'));
        };

        req.open('POST', endpoint);
        req.setRequestHeader('Content-Type', 'application/json');
        req.send(JSON.stringify(params));
      });
    },
    [],
  );

  const beaconRequest = useCallback(
    async (endpoint: string, params: BeaconParams): Promise<void> => {
      try {
        // if (navigator.sendBeacon) {
        const success = await sendBeaconRequest(endpoint, params);
        if (!success) {
          console.error('beaconRequest Error: sendBeacon failed');
          await makeHttpRequest(endpoint, params);
        }
        // } else {
        //   await makeHttpRequest(endpoint, params);
        // }
      } catch (error) {
        throw error;
      }
    },
    [sendBeaconRequest, makeHttpRequest],
  );

  return { beaconRequest };
}
